import React from 'react';
import PropTypes from 'prop-types';
import { useSimulationLogic } from './SimulationLogic';
import Button from '../../form/Button/Button';
import SimulationResult from './results/SimulationResult';
const Simulation = ({
    propertyData,
    clientData,
    creditAnalysisData,
    walletData,
    onSimulationComplete,
    showResult,
    showWalletCard,
    simulationResult,
    isMRV,
    isPropostaIdeal,
    setIsPrintEnabled,
    setShowResult
}) => {
    const {
        isSimulating,
        handleSimulate,
    } = useSimulationLogic(
        propertyData,
        clientData,
        creditAnalysisData,
        walletData,
        onSimulationComplete,
        showWalletCard,
        { isPropostaIdeal, isMRV }
    );

    const handleSimulateClick = () => {
        if (setIsPrintEnabled) setIsPrintEnabled(false);
        if (setShowResult) setShowResult(false);
        handleSimulate();
    };

    return (
        <>
            <Button
                id="btnSimular"
                variant="primary"
                fullWidth
                className="mt-4"
                onClick={handleSimulateClick}
                disabled={isSimulating}
            >
                {isSimulating ? 'Processando...' : 'Simular Proposta'}
            </Button>

            {showResult && simulationResult && (
                <div id="resultadoSimulacao">
                    <SimulationResult 
                        result={simulationResult} 
                        isMRV={isMRV} 
                        pagadoria={clientData?.pagadoria || false} 
                    />
                </div>
            )}
        </>
    );
};

Simulation.propTypes = {
    propertyData: PropTypes.object,
    clientData: PropTypes.shape({
        pagadoria: PropTypes.bool,
        buyers: PropTypes.arrayOf(PropTypes.shape({
            income: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            birthDate: PropTypes.string
        })).isRequired,
        valorComissao: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    }),
    creditAnalysisData: PropTypes.object,
    walletData: PropTypes.object,
    onSimulationComplete: PropTypes.func.isRequired,
    showResult: PropTypes.bool,
    showWalletCard: PropTypes.bool,
    simulationResult: PropTypes.object,
    isMRV: PropTypes.bool,
    isPropostaIdeal: PropTypes.bool,
    setIsPrintEnabled: PropTypes.func,
    setShowResult: PropTypes.func
};

export default Simulation;